import { Grid, GridItem, Text } from '@chakra-ui/react';
import { startCase } from 'lodash/fp';

import { formatValue } from '../../utils';

export function ReportGrid({ data }: any) {
  // Remove empty fields
  data = Object.fromEntries(
    Object.entries(data).filter(([_, v]) => {
      if (
        (typeof v === 'number' && !isNaN(v) && v > 0) ||
        (typeof v === 'string' && v.trim().length > 0)
      )
        return true;
      return false;
    })
  );

  return (
    <>
      <Grid gap={10} display="inline-flex" mx="4" my="3" mt="0">
        {Object.entries(data).map(([k, v]) => (
          <GridItem key={k}>
            <Text fontSize="sm" as="b">{`${startCase(k)}`}</Text>
            <Text fontSize="md">{formatValue(k, v)}</Text>
          </GridItem>
        ))}
      </Grid>
    </>
  );
}

export default ReportGrid;
